import React from 'react';
import {Link} from 'react-router-dom';

import {useEventTracking} from 'src/hooks/useEventTracking';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';


type Props = {
    caption?: string,
    profileId?: number,
    tab?: string,
    blank?: boolean,
};

export const RoleLink = ({profileId, caption, blank, tab = ''}: Props) => {
    const {roleOpen} = useEventTracking();

    const content = (
        <EllipsisTextHint title={caption || 'Deleted role'}>
            {caption || 'Deleted role'}
        </EllipsisTextHint>
    );

    return profileId && caption ? (
        <Link to={`/roles/${profileId}/${tab}`} onClick={roleOpen} target={blank ? '_blank' : undefined}>
            {content}
        </Link>
    ) : content;
};
